import tippy from "tippy.js"
import { ReactRenderer } from "@tiptap/react"
import { MentionList } from "./MentionList"

// To have a smooth transition from the previous AtMentionTextarea, we need to retain the difference between display and stored value of mentions
// This field is previously setup to have a translation layer between display and stored text value
// This is because for search looks for {"text__qscontains": u"[@{}|||".format(user.username)} to filter mentioned users

// mentionTags takes the shape of displayValue as the key and storeValue as the value. E.g., {@TéstAccount: '[@test_no_ascii|||Tést Account]’}
export const formatToStore = (value, mentionTags) => {
    // Mantine rich textarea will treat removed text as "<p></p>"
    // but we want to leave it as empty string for sheet and other features on the site
    if (value === "<p></p>") {
        return ""
    }

    return Object.keys(mentionTags).reduce((acc, tag) => acc.split(tag).join(mentionTags[tag]), value)
}

export const formatToDisplay = (value, mentionTags) => {
    // step 1: replace stored mention structure with display structure
    const displayValue = Object.keys(mentionTags).reduce((acc, tag) => acc.split(mentionTags[tag]).join(tag), value)
    // step 2: old textarea text has line breaks that are not recognizable by rich text editor
    // replace line breaks with paragraph tags
    if (displayValue.includes("\n")) {
        return displayValue
            .split("\n")
            .map((line) => line && "<p>" + line.trim() + "</p>")
            .join("")
    }
    return displayValue
}
